import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { SetColorsService } from 'core'

@Component({
  selector: 'bmprod-cookie-policy-page',
  templateUrl: './bmprod-cookie-policy-page.component.html',
  styleUrls: ['./bmprod-cookie-policy-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodCookiePolicyPageComponent implements OnInit {
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
